"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var primary_1 = require("./styles/primary");
var secondary_1 = require("./styles/secondary");
var tertiary_1 = require("./styles/tertiary");
var handleClick = function (isDisabled, onClick) { return function (e) {
    if (isDisabled !== true && onClick !== undefined) {
        onClick(e);
    }
}; };
var getStyleByAppearance = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, isDisabled = _a.isDisabled, label = _a.label, onClick = _a.onClick, shouldFitToContainer = _a.shouldFitToContainer, size = _a.size, variant = _a.variant;
    switch (variant) {
        case 'primary':
            return react_1.default.createElement(primary_1.PrimaryButton, { className: className, "data-test-id": dataTestId, isDisabled: isDisabled, onClick: handleClick(isDisabled, onClick), shouldFitToContainer: shouldFitToContainer, size: size }, label);
        case 'secondary':
            return react_1.default.createElement(secondary_1.SecondaryButton, { className: className, "data-test-id": dataTestId, isDisabled: isDisabled, onClick: handleClick(isDisabled, onClick), shouldFitToContainer: shouldFitToContainer, size: size }, label);
        case 'tertiary':
            return react_1.default.createElement(tertiary_1.TertiaryButton, { className: className, "data-test-id": dataTestId, isDisabled: isDisabled, onClick: handleClick(isDisabled, onClick), shouldFitToContainer: shouldFitToContainer, size: size }, label);
        default:
            return null;
    }
};
var Button = function (props) { return (getStyleByAppearance(__assign({}, props))); };
Button.defaultProps = {
    label: '',
    size: 'small',
    variant: 'primary'
};
exports.default = Button;
__exportStar(require("./types"), exports);
